import React from 'react';
import './Loaders.scss';

export const Spinner = ({ className="", size="", color='', themeColor='', linear }) => (
  <div className={`orbit-loader ${className} ${size} ${themeColor} ${linear ? 'linear' : ''}`}>
		<div className="top" style={{background: color}} />
		<div className="right" style={{background: color}} />
		<div className="bottom" style={{background: color}} />
		<div className="left" style={{background: color}} />
	</div>
)



// WEBPACK FOOTER //
// ./src/components/Loaders/Loaders.js